export default __webpack_public_path__ + "static/media/Hair_4_M_C4.aa33d783.svg";